import { getTopBodyHolders, getTopHeadHolders } from 'helpers/asyncRequests'
import React, { useState } from 'react'
import './HoldersModal.css'
import 'bootstrap'
import HoldersStatsItem from './HolderStatsItem'
import { useModalDisableScroll } from 'helpers/hooks'

export default function HoldersModal({ children, shown, close }) {
    useModalDisableScroll(shown)

    const [topBodyHolders, setTopBodyHolders] = useState()
    const [topHeadHolders, setTopHeadHolders] = useState()
    React.useEffect(() => {
        Promise.all([getTopBodyHolders(), getTopHeadHolders()]).then(
            ([bodyHolders, headHolders]) => {
                setTopBodyHolders(bodyHolders)
                setTopHeadHolders(headHolders)
            }
        )
    }, [])

    return shown ? (
        <div
            className="holdersmodal-backdrop"
            onClick={() => {
                close()
            }}
        >
            <div
                className="holdersmodal-content"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <h1>holders stats</h1>
                <div className="accordion" id="holdersStats">
                    <HoldersStatsItem
                        id="bodies"
                        heading="Lunicorn Body stats"
                        state={topBodyHolders}
                        show
                    />
                    <HoldersStatsItem
                        id="heads"
                        heading="Lunicorn Head stats"
                        state={topHeadHolders}
                    />
                </div>

                <button
                    onClick={() => {
                        close()
                    }}
                    className="okButtonHolders"
                >
                    OK
                </button>
            </div>
        </div>
    ) : null
}
